import reducers from './reducer';
import { persistStore } from 'redux-persist';
import { eventCatch } from '../context/EventReduxContext';
import * as Sentry from '@sentry/react';
import config from '../config';
import { configureStore, Tuple } from '@reduxjs/toolkit';

export default function configureClientStore(cookieStorage: any, ssrState: any = {}) {
  const store: any = configureStore({
    reducer: reducers(cookieStorage),
    preloadedState: ssrState,
    devTools: process.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) => {
      const defaultMiddleware = getDefaultMiddleware({
        thunk: true,
        serializableCheck: false,
        immutableCheck: false,
      });
      return typeof window !== 'undefined' ? defaultMiddleware.concat(eventCatch as any) : defaultMiddleware;
    },
    enhancers: (getDefaultEnhancers) => {
      if (config.isErrorReportingEnabled === 'true') {
        const sentryReduxEnhancer = Sentry.createReduxEnhancer({
          stateTransformer: (state) => {
            return {
              ...state,
              category: null,
              locale: null,
            };
          },
        });
        return getDefaultEnhancers().concat(new Tuple(sentryReduxEnhancer));
      }
      return getDefaultEnhancers();
    },
  });

  store.asyncReducers = {}; // Async reducer registry

  const persistor = persistStore(store);

  return { store, persistor };
}

export async function configureSsrStore(cookieStorage: any) {
  const store: any = configureStore({
    reducer: reducers(cookieStorage),
    preloadedState: {},
    devTools: process.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) => {
      const defaultMiddleware = getDefaultMiddleware({
        thunk: true,
        serializableCheck: false,
        immutableCheck: false,
      });
      return typeof window !== 'undefined' ? defaultMiddleware.concat(eventCatch as any) : defaultMiddleware;
    },
  });

  store.asyncReducers = {}; // Async reducer registry

  const persistor = persistStore(store);

  return { store, persistor };
}
